"use client";

import { LazyRichText } from "@app/_blocks/RichText/LazyRichText";
import Button from "@app/_components/Button/Button";
import Link from "@app/_components/Link";
import { Heading } from "@app/_components/ui";
import type { FooterBannerFragment } from "@server/gql/graphql";

import { cn } from "@/lib/utils";

type FooterBannerContentProps = {
  className?: string;
  locale?: string;
  market: string;
  footerBanner?: FooterBannerFragment | null;
};

export const FooterBannerContent = ({
  className,
  footerBanner,
  market,
  locale,
}: FooterBannerContentProps) => {
  if (!footerBanner) {
    return null;
  }

  const { title, paragraph, link, linkText } = footerBanner;
  const linkSlug = link?.slug;

  return (
    <section
      className={cn(
        "flex flex-col items-stretch bg-primary xl:max-h-120",
        className,
      )}
    >
      <div className="flex flex-col items-center gap-6 px-8 py-9 text-center md:py-12">
        {title && (
          <Heading as="h3" size={5} className="uppercase">
            {title}
          </Heading>
        )}
        {paragraph && (
          <LazyRichText
            className="max-w-2xl"
            content={paragraph}
            locale={locale}
            market={market}
          />
        )}
        {linkSlug && linkText && (
          <Button
            type="button"
            as={Link}
            locale={locale}
            href={linkSlug}
            className="btn-outlined h-12 min-w-60 border px-4 hover:bg-black hover:text-white max-md:w-full"
          >
            {linkText}
          </Button>
        )}
      </div>
    </section>
  );
};
